/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { FEEDBACK_QUESTION_GROUPS } from './feedbackConstants.js';

const isMeaningfulSelection = value => typeof value === 'string' && value.trim() !== '' && value !== 'none';

/**
 * Build the userFeedback string sent to the feedback API from chip selections and free text.
 * @param {object} params
 * @param {Record<string, string | undefined>} params.selections - keyed by question group id
 * @param {string} [params.freeText]
 * @param {(stringId: string) => string} params.formatLabel
 * @returns {string}
 */
export const buildFeedbackUserFeedbackText = ({ selections = {}, freeText = '', formatLabel }) => {
  const structuredLines = FEEDBACK_QUESTION_GROUPS.reduce((lines, group) => {
    const selectedValue = selections[group.id];

    if (!isMeaningfulSelection(selectedValue)) {
      return lines;
    }

    const choice = group.choices.find(item => item.value === selectedValue);

    if (!choice) {
      return lines;
    }

    lines.push(`${formatLabel(group.sectionLabelStringId)}: ${formatLabel(choice.labelStringId)}`);

    return lines;
  }, []);

  const trimmedFreeText = typeof freeText === 'string' ? freeText.trim() : '';

  if (structuredLines.length === 0) {
    return trimmedFreeText;
  }

  if (trimmedFreeText === '') {
    return structuredLines.join('\n');
  }

  return `${structuredLines.join('\n')}\n\n${trimmedFreeText}`;
};
